import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39c60438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manga-access" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "漫画浏览量", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: $setup.mangaList,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "mangaName",
          label: "漫画名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "num",
          label: "Name",
          width: "浏览量"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]),
    _createCommentVNode(" <div class=\"manga-item\" v-for=\"item in mangaList\" :key=\"item.mangaId\">{{ item.mangaName }}:{{ item.num }}</div> ")
  ]))
}